import React from "react";
import { PropTypes } from "prop-types";
import { withTranslation } from "react-i18next";

import SwitchOnOff from "components/common/tools/SwitchOnOff";

function ShareConfig({ t, onChangeOpt, shareComponent }) {
  const share_target = [
    "share_facebook",
    "share_twitter",
    "share_linkedin",
    "share_mail",
    "share_threads",
    "display_custom_id",
  ];

  return (
    <div className="editor-share-section editor-form-section section-separator">
      <div className="editor-form-section-title">{t("shareLabel")}</div>

      {share_target.map((target) => (
        <div key={target} className="editor-form-row editor-form-row-inline">
          <div className="editor-form-input">
            <SwitchOnOff
              name={target}
              iconName=""
              checked={shareComponent.params[target]}
              size="sm"
              onChange={(value) => onChangeOpt(target, value)}
            />
          </div>
          <div className="editor-form-label">{t(target)}</div>
        </div>
      ))}
    </div>
  );
}

ShareConfig.propTypes = {
  onChangeOpt: PropTypes.func.isRequired,
  shareComponent: PropTypes.any,
  t: PropTypes.func.isRequired,
};

export default withTranslation("editor-platform")(ShareConfig);
